import { AccessRolesRepository } from '@/AccessRoles/domain/AccessRolesRepository'
import { HttpModel, PaginationModel } from '@/Shared/domain'
import { AccessRolesModel } from '../domain'

interface IAccessRoles {
    getAccessRoles: (page: number, numberOfRecordsPerPage: number) => Promise<HttpModel<PaginationModel<AccessRolesModel>>>
}

export const AccessRolesContract = (accessRolesRepository: AccessRolesRepository): IAccessRoles => ({
    getAccessRoles: async (page: number, numberOfRecordsPerPage: number): Promise<HttpModel<PaginationModel<AccessRolesModel>>> => {
        return await accessRolesRepository.GetAccessRolesData(page, numberOfRecordsPerPage)
    }
})
